import React from 'react';
import images from '../../helpers/images';

function Footer(){
    return (
        <footer className="main-footer">
        {/* To the right */}
        {/* <div className="float-right d-none d-sm-inline">
            Anything you want
        </div> */}
        {/* Default to the left */}
        <strong>Copyright &copy; 2023 <a href="https://jma-electronics.com">JMA Electronics</a>.</strong> All rights reserved.
        </footer>
    )
}

export default Footer;
